import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import {createPinia} from "pinia";
import autoSize from "@/directives/autoSize";
import VueApexCharts from 'vue3-apexcharts'

const pinia = createPinia();

createApp(App)
	.use(pinia)
	.use(router)
	.use(VueApexCharts)
	.directive('auto-size', autoSize)
	.mount('#app')
